import React from 'react';
import { Helmet } from 'react-helmet-async';
import BlogItems from './BlogItems';
import TopHeader from '../../components/Top/TopHeader';

const Blog: React.FC = () => {
  return (
    <div>
      <Helmet>
        <title>Hyderabad Real Estate Blog | Latest News, Tips & Market Updates</title>
        <meta name="description" content="Explore Hyderabad’s real estate market with expert blogs, property news, home buying guides and tips, Get the latest updates now!" />
        <meta name="keywords" content="Hyderabad real estate, hyderabad real estate latest news, hyderabad real estate news, real estate in hyderabad, real estate hyderabad, real estate hyderabad latest, real estate investing, Home buying guide, Hyderabad real estate market updates, Housing market" />
      </Helmet>
      <TopHeader value="Blog" />
      <BlogItems />
    </div>
  );
};

export default Blog;